

// import React, { useRef, useState, useEffect } from "react";
// import "bootstrap/dist/css/bootstrap.min.css";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";

// const Card = () => {
//   const scrollRef = useRef(null);
//   const [categories, setCategories] = useState([]);
// const navigate = useNavigate();
//   const [isDown, setIsDown] = useState(false);
//   const [startX, setStartX] = useState(0);
//   const [scrollLeft, setScrollLeft] = useState(0);
//   const [dragging, setDragging] = useState(false);

//   // ✅ Fetch categories from API
//   useEffect(() => {
//     axios
//       .get("https://vantara.datacubeglobal.com/api/api-categories")
//       .then((res) => {
//         if (res.data.status === "success") {
//           setCategories(res.data.data);
//         }
//       })
//       .catch((err) => {
//         console.error("Error fetching categories:", err);
//       });
//   }, []);

//   const handleMouseDown = (e) => {
//     setIsDown(true);
//     setDragging(false);
//     setStartX(e.pageX - scrollRef.current.offsetLeft);
//     setScrollLeft(scrollRef.current.scrollLeft);
//   };

//   const handleMouseLeave = () => setIsDown(false);
//   const handleMouseUp = () => {
//     setIsDown(false);
//     setTimeout(() => setDragging(false), 0);
//   };

//   const handleMouseMove = (e) => {
//     if (!isDown) return;
//     e.preventDefault();
//     setDragging(true);
//     const x = e.pageX - scrollRef.current.offsetLeft;
//     const walk = (x - startX) * 1.2;
//     scrollRef.current.scrollLeft = scrollLeft - walk;
//   };

//   const handleClick = (e) => {
//     if (dragging) {
//       e.preventDefault();
//       e.stopPropagation();
//     }
//   };

//   return (
//     <div className="container-fluid my-4 px-3">
//         <div className="text-center mb-3">
//     <h5
//       style={{
//       fontWeight: "bold !important",   
//         letterSpacing: "0.5px",
     
//     fontSize: "2rem",
//         color: "#555",
//       }}
//     >
//       Shop By Category
//     </h5><br/>
//   </div>
//       <div className="position-relative">
//         <div
//           className="d-flex gap-3 overflow-auto px-1"
//           ref={scrollRef}
//           style={{
//             scrollBehavior: "smooth",
//             cursor: isDown ? "grabbing" : "grab",
//             scrollbarWidth: "none",
//             msOverflowStyle: "none",
//           }}
//           onMouseDown={handleMouseDown}
//           onMouseLeave={handleMouseLeave}
//           onMouseUp={handleMouseUp}
//           onMouseMove={handleMouseMove}
//         >
//           <style jsx>{`
//             .d-flex::-webkit-scrollbar {
//               display: none;
//             }
//           `}</style>

//           {categories.map((item) => {
//             const imgSrc = item.image
//               ? `https:\/\/vantara.datacubeglobal.com\/storage/categoryImage/${item.image}`
//               : "https://via.placeholder.com/220x220?text=No+Image";

//             return (
//               <div
//                 key={item.id}
//                 className="card border-0 flex-shrink-0"
//                 style={{
//                   width: "220px",
//                   borderRadius: "16px",
//                   overflow: "hidden",
//                   position: "relative",
//                   cursor: "pointer",
//                   // boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
//                 }}
//                 onClick={handleClick}
//               >
//                 <img
//                   src={imgSrc}
//                    onClick={() => navigate(`/products/${item.id}`)}
//                   alt={item.name}
//                   draggable={false}
//                   className="card-img-top"
//                   style={{ height: "220px",  objectFit: "contain", width: "100%"  , backgroundColor: "#FFFFFFFF",}}
//                 />
//                 <div
//   className="position-absolute bottom-0 bg-white text-dark fw-semibold rounded-pill px-3 py-1 shadow"
//   style={{
//     marginBottom: "12px",
//     fontSize: "0.8rem",
  
//     fontWeight: 400,
//     letterSpacing: "0.2px",
//     textTransform: "uppercase",
//     left: "50%",
//     transform: "translateX(-50%)", // center dynamically based on width
//     whiteSpace: "nowrap", // prevent wrapping
//   }}
// >
//   {item.name}
// </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Card;
import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Card = () => {
  const scrollRef = useRef(null);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [dragging, setDragging] = useState(false);

  // ✅ Fetch categories from API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get("https://vantara.datacubeglobal.com/api/api-categories");
        if (res.data.status === "success") {
          setCategories(res.data.data);
        }
      } catch (err) {
        console.error("Error fetching categories:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // 🖱️ Mouse drag scroll handlers
  const handleMouseDown = (e) => {
    setIsDown(true);
    setDragging(false);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseLeave = () => setIsDown(false);
  const handleMouseUp = () => {
    setIsDown(false);
    setTimeout(() => setDragging(false), 0);
  };

  const handleMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    setDragging(true);
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.2;
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  const handleClick = (e) => {
    if (dragging) {
      e.preventDefault();
      e.stopPropagation();
    }
  };

  // 🩶 Skeleton loader placeholders
  const SkeletonCard = () => (
    <div
      className="card border-0 flex-shrink-0 shimmer"
      style={{
        width: "220px",
        height: "240px",
        borderRadius: "16px",
        overflow: "hidden",
        background: "#f0f0f0",
        position: "relative",
      }}
    >
      <div className="skeleton-img" style={{ height: "220px" }}></div>
      <div
        className="skeleton-text mx-auto mt-2"
        style={{
          height: "20px",
          width: "80px",
          borderRadius: "10px",
          background: "#e0e0e0",
        }}
      ></div>
    </div>
  );

  return (
    <div className="container-fluid my-4 px-3">
      <div className="text-center mb-3">
        <h2
        className="text-center mb-4 fw-bold"
          // style={{
          //   fontWeight: "bold",
          //   letterSpacing: "0.5px",
          //   fontSize: "2rem",
          //   color: "#555",
          // }}
          
        >
          Shop By Category
        </h2>
        <br />
      </div>

      <div className="position-relative">
        <div
          className="d-flex gap-3 overflow-auto px-1"
          ref={scrollRef}
          style={{
            scrollBehavior: "smooth",
            cursor: isDown ? "grabbing" : "grab",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          onMouseDown={handleMouseDown}
          onMouseLeave={handleMouseLeave}
          onMouseUp={handleMouseUp}
          onMouseMove={handleMouseMove}
        >
          <style>{`
            .d-flex::-webkit-scrollbar { display: none; }

            /* Shimmer Animation */
            @keyframes shimmer {
              0% { background-position: -200px 0; }
              100% { background-position: 200px 0; }
            }

            .skeleton-img, .skeleton-text {
              background: linear-gradient(
                90deg,
                #f0f0f0 25%,
                #e0e0e0 50%,
                #f0f0f0 75%
              );
              background-size: 400px 100%;
              animation: shimmer 1.5s infinite linear;
            }
          `}</style>

          {/* 🌀 Loading state */}
          {loading
            ? Array.from({ length: 6 }).map((_, i) => <SkeletonCard key={i} />)
            : categories.map((item) => {
                const imgSrc = item.image
                  ? `https://vantara.datacubeglobal.com/storage/categoryImage/${item.image}`
                  : "https://via.placeholder.com/220x220?text=No+Image";

                return (
                  <div
                    key={item.id}
                    className="card border-0 flex-shrink-0"
                    style={{
                      width: "220px",
                      borderRadius: "16px",
                      overflow: "hidden",
                      position: "relative",
                      cursor: "pointer",
                    }}
                    onClick={handleClick}
                  >
                    <img
                      src={imgSrc}
                      onClick={() => navigate(`/products/${item.id}`)}
                      alt={item.name}
                      draggable={false}
                      className="card-img-top"
                      style={{
                        height: "220px",
                        objectFit: "contain",
                        width: "100%",
                        backgroundColor: "#FFFFFF",
                      }}
                      onError={(e) =>
                        (e.target.src =
                          "https://via.placeholder.com/220x220?text=No+Image")
                      }
                    />
                        {/*shadow  */}
                   <div
  className="position-absolute bottom-0 bg-white text-dark fw-semibold rounded-pill px-3 py"
  style={{
    marginBottom: "12px",
    fontSize: "0.8rem",
    fontWeight: 400,
    letterSpacing: "0.2px",
    textTransform: "uppercase",
    left: "50%",
    transform: "translateX(-50%)",
    whiteSpace: "nowrap",
    marginTop: "4px",
    cursor: "pointer", // optional, makes it look clickable
  }}
  onClick={handleClick}
>
  {item.name}
</div>

                  </div>
                );
              })}
        </div>
      </div>
    </div>
  );
};

export default Card;
